//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  name: 'loader',
  data() {
    return {
      error_text: document.querySelector('#error_text').value,
    }
  },
  computed: {
    ...mapGetters(['get']),
    loading() {
      return this.get('loading')
    },
    error() {
      return this.get('error')
    },
    error_msg() {
      return this.get('error_msg')
    },
    error_array() {
      return this.error_msg ? this.error_msg : this.error_text.split('')
    },
  },
}
